import {Injectable} from "@angular/core";
import {HttpClient} from "@angular/common/http";

import {ResourceService} from "../../shared/comun/services/resource.service";
import {Usuario, UsuariosResumenResponse} from "../models/usuario.model"
import {EmpresaService} from "../../core/services/empresa.service";
import {appService} from "../../credentials";

@Injectable()
export class UsuarioService {

    constructor(private http: HttpClient,
                private resourceService: ResourceService,
                private empresaService:EmpresaService) {
    }

    /**
     * @desc Obtiene el token del usuario que esta
     * solicitando autorización para iniciar sesión
     * @param {Object} usercreds - Username, Password y Empresa
     */
    getLogin(usercreds) {
        return new Promise((resolve) => {
            let credenciales = 'username=' + usercreds.username + '&password=' + usercreds.password;
            let headers = {'Content-Type': 'application/x-www-form-urlencoded'};
            let options = {headers: headers};
            this.http.post<TokenResponse>(appService.ws_seguridad_loguin, credenciales, options).subscribe((data) => {
                    if (data.token) {
                        window.localStorage.setItem('auth_key', data.token);
                        this.empresaService.storage_set_empresa(usercreds.empresa);
                        resolve(true);
                    }
                }, (err) => {
                    resolve(false);
                }
            );
        });
    }

    /**
     * @desc Obtiene segun el token enviado como parametro,
     * información del usuario logueado
     * @returns {Observable<TResult>}
     */
    getUsuarioLogueado(token) {
        let options = this.resourceService.getRequestOptions(token);
        return this.http.get<Usuario>(appService.ws_seguridad_usuario_logueado, options);
    }

    /**
     * @desc Obtiene true o false sobre el permiso consultado
     * @returns {Observable<TResult>}
     */
    tiene_permiso(permiso) {
        var token = window.localStorage.getItem('auth_key')
        let permisos = {permiso: permiso};
        let options = this.resourceService.getRequestOptions(token, permisos);
        return this.http.get(appService.ws_seguridad_usuario_tiene_permiso, options);
    }

    /**
     * Devuelve lista de usuarios con datos principales
     * @desc Obtiene la lista de usuarios
     * @param {String} token - Cadena de caracteres para la autenticacion en el API
     * @returns {Object|Array}
     */
    getUsuarios(token: string) {
        let options = this.resourceService.getRequestOptions(token);
        return this.http.get<UsuariosResumenResponse>(appService.ws_seguridad_usuario_lista , options)
    }
}

export interface TokenResponse {
    token: string;
}
